import './functions';
import { wrapperBuilder } from './build';

export const BiometricsWrapper = wrapperBuilder.build();
